/**
 * 通用代码管理
 * @author
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async getFormDetail(keyId) {
		return request(api.comm.BASE_CODE + "/getOne?typeNo=" + keyId, METHOD.GET);
	},
	async saveFormDetail(result) {
		return request(api.comm.BASE_CODE, METHOD.POST, result);
	},
}


export default {dataApi}